import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GatewayRpcService} from "./gateway";
import {DocumentRpcService} from "./document";
import {BatchRpcService} from "./batch";
import {QueueRpcService} from "./queue";
import {MessageService} from "./message";

@NgModule({
  declarations: [],
  providers: [
    GatewayRpcService,
    DocumentRpcService,
    BatchRpcService,
    QueueRpcService,
    MessageService
  ],
  exports: [],
  imports: [
    CommonModule,
  ],
})
export class AlphaServicesModule {
}

